import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer, { TableContainerProps } from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import ProgressComponent from '~/components/atoms/progress/ProgressComponent';
import { useThousandFormatter } from '~/utils/useThousandFormatter';

type TableItem = {
  id: number | string;
  type: string;
  scansCount: number;
  rate?: number;
};

type BasicTableProps = TableContainerProps & {
  data: TableItem[];
  title: string;
};

export default function BasicTable({ data = [], title, ...props }: BasicTableProps) {
  const { t } = useTranslation();
  const formatNumber = useThousandFormatter();

  return (
    <TableContainer component={Paper} {...props}>
      <Table sx={{ minWidth: '100%' }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '25%' }}>#</TableCell>
            <TableCell sx={{ width: '25%' }} align="left">
              {title}
            </TableCell>
            <TableCell sx={{ width: '25%' }} align="left">
              {t('labels:scans')}
            </TableCell>
            <TableCell sx={{ width: '25%' }} align="center">
              %
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item) => (
            <TableRow key={item.id}>
              <TableCell sx={{ width: '25%' }} component="th" scope="row">
                {item.id}
              </TableCell>
              <TableCell sx={{ width: '25%' }} align="left">
                {item.type}
              </TableCell>
              <TableCell sx={{ width: '25%' }} align="left">
                {formatNumber(item.scansCount)}
              </TableCell>
              <TableCell sx={{ width: '25%' }} align="center">
                {typeof item.rate === 'number' ? <ProgressComponent value={item.rate} /> : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
